export const pathes = {
    BASE_PATH:"/taxi-passenger",
    DEFAULT: "/",
    QR_PAYMENT: "/qr-payment",
    CHANGE_COST: "/change-cost",
    COST_PAYMENT: "/cost-payment",
    SUCCESS_PAYMENT: "/success",
    FACTOR: "/factor",
    PAYMENT_CODE: "/payment-code",
    WALLET: "/wallet",
    PROFILE: "/profile",
}